import { Link } from 'react-router-dom';
import { articles, categories } from '@/mocks/articles';

export default function LatestUpdates() {
  const latest = [...articles].sort(
    (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
  ).slice(0, 6);

  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
              最新更新
            </h2>
            <p className="mt-2 text-sm md:text-base text-foreground-600">
              保持关注，不错过任何精彩
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-5 md:gap-6">
          {latest.map((article) => {
            const cat = categories.find((c) => c.slug === article.category);
            return (
              <Link
                key={article.id}
                to={`/article/${article.id}`}
                className="group flex flex-col sm:flex-row gap-4 p-4 md:p-5 bg-background-100 rounded-xl border border-background-200/70 transition-all duration-300 hover:-translate-y-0.5 cursor-pointer"
              >
                <div className="w-full sm:w-48 h-32 overflow-hidden rounded-lg flex-shrink-0">
                  <img
                    src={article.cover}
                    alt={article.title}
                    title={`${article.title} - 今日同人库`}
                    className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                    loading="lazy"
                  />
                </div>
                <div className="flex-1 min-w-0 flex flex-col justify-between">
                  <div>
                    <div className="flex items-center gap-2 mb-1.5">
                      {cat && (
                        <span className="px-2 py-0.5 text-xs bg-secondary-100 text-secondary-700 rounded-md whitespace-nowrap">
                          {cat.name}
                        </span>
                      )}
                      <span className="text-xs text-foreground-500">{article.createdAt}</span>
                    </div>
                    <h3 className="text-base font-heading font-semibold text-foreground-950 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                      {article.title}
                    </h3>
                    <p className="mt-1.5 text-sm text-foreground-600 line-clamp-2 leading-relaxed">
                      {article.excerpt}
                    </p>
                  </div>
                  <div className="flex items-center gap-4 mt-3 text-xs text-foreground-500">
                    <span className="flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-user-line text-sm w-3.5 flex items-center justify-center"></i>
                      {article.author}
                    </span>
                    <span className="flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-eye-line text-sm w-3.5 flex items-center justify-center"></i>
                      {article.readCount >= 10000 ? `${(article.readCount / 10000).toFixed(1)}万` : article.readCount}
                    </span>
                    <span className="flex items-center gap-1 whitespace-nowrap">
                      <i className="ri-heart-line text-sm w-3.5 flex items-center justify-center"></i>
                      {article.likeCount}
                    </span>
                  </div>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}